import humps from 'humps';
import { toastr } from 'react-redux-toastr';
import * as fetchUtils from 'app/utils/FetchUtils';
import { createActionName } from './bid';

const initialState = null;

export const CLIENTS_GET = createActionName('CLIENTS_GET');

export default function client(state = initialState, action) {
    switch (action.type) {
        case CLIENTS_GET:
            return {
                ...action.data,
            };
        default:
            return state;
    }
}

export function getClient(id, cid) {
    return (dispatch) =>
        fetchUtils
            .getJSON(`${process.env.REACT_APP_CS_OB_API_HOST}/entities/${cid}/customer`)
            .then((d) => humps.camelizeKeys(d))
            .then((data) => {
                dispatch({ type: CLIENTS_GET, data, id });
                return data;
            })
            .catch((ex) =>
                fetchUtils.handleErrorV2(dispatch, ex).then((m) => {
                    toastr.error('Error retrieving customer data', m);
                }),
            );
}
